// extracted by mini-css-extract-plugin
export var pillWrapper = "_yk-0";
export var showOverflow = "_yk-1";